// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + ".js?v=" + {"7004":"735308fa73b9edee73bd","8236":"1e233d93fd8fdfba7897"}[chunkId] + "";
};